// Unpublished Work © 2020-2024 Deere & Company.

export const UPDATE_EQUIPMENT_AREAS = 'UPDATE_EQUIPMENT_AREAS';
export const UPDATE_EQUIPMENT_TYPES = 'UPDATE_EQUIPMENT_TYPES';
export const SET_INVENTORY_PARTS = 'SET_INVENTORY_PARTS';

export function updateEquipmentAreas(equipmentAreas) {
    return {
        type: UPDATE_EQUIPMENT_AREAS,
        equipmentAreas
    };
}

export function updateEquipmentTypes(equipmentTypes) {
    return {
        type: UPDATE_EQUIPMENT_TYPES,
        equipmentTypes
    };
}

export function setInventoryParts(inventoryParts) {
    return {
        type: SET_INVENTORY_PARTS,
        inventoryParts
    };
}
